import HierarchyComponent from '../../../components/hierarchy_fields/HierarchyFieldSelectorComponent.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class HierarchySelectorRenderer extends InlineComponent {
  define() {
    this.component = HierarchyComponent;
    this.data = {
      definitions: this.element.data('definitions'),
      name: this.element.data('name'),
      value: _.isEmpty(this.element.data('value') + '')
        ? ''
        : this.element.data('value'),
    };
  }
};
